const CustomContentStyle = `
  span.mce-match-marker {
  background-color : yellow !important;
  }

  span.mce-match-marker-selected {
  border-style: dotted;
  border-width: 1px
  background-color : yellow !important;
  }

  @font-face {
    font-family: IRANSans;
    font-style: normal;
    font-weight: bold;
    src: url("/fonts/iransans/eot/IRANSansWeb_Bold.eot");
    src: url("/fonts/iransans/eot/IRANSansWeb_Bold.eot?#iefix") format("embedded-opentype"), url("/fonts/iransans/woff2/IRANSansWeb_Bold.woff2") format("woff2"),
    url("/fonts/iransans/woff2/IRANSansWeb_Bold.woff2") format("woff2"),
    url("/fonts/iransans/ttf/IRANSansWeb_Bold.ttf") format("truetype");
    font-display: swap;
  }

  @font-face {
    font-family: IRANSans;
    font-style: normal;
    font-weight: 400;
    src: url("/fonts/iransans/eot/IRANSansWeb_Medium.eot");
    src: url("/fonts/iransans/eot/IRANSansWeb_Medium.eot?#iefix") format("embedded-opentype"), url("/fonts/iransans/woff2/IRANSansWeb_Medium.woff2") format("woff2"),
    url("/fonts/iransans/woff2/IRANSansWeb_Medium.woff2") format("woff2"),
    url("/fonts/iransans/ttf/IRANSansWeb_Medium.ttf") format("truetype");
    font-display: swap;
  }

  @font-face {
    font-family: IRANSans;
    font-style: normal;
    font-weight: 200;
    src: url("/fonts/iransans/eot/IRANSansWeb_Light.eot");
    src: url("/fonts/iransans/eot/IRANSansWeb_Light.eot?#iefix") format("embedded-opentype"), url("/fontsR/iransans/woff2/IRANSansWeb_Light.woff2") format("woff2"),
    url("/fonts/iransans/woff2/IRANSansWeb_Light.woff2") format("woff2"),
    url("/fonts/iransans/ttf/IRANSansWeb_Light.ttf") format("truetype");
    font-display: swap;
  }

  @font-face {
    font-family: IRANSans;
    font-style: normal;
    font-weight: 100;
    src: url("/fonts/iransans/eot/IRANSansWeb_UltraLight.eot");
    src: url("/fonts/iransans/eot/IRANSansWeb_UltraLight.eot?#iefix") format("embedded-opentype"), url("/fonts/iransans/woff2/IRANSansWeb_UltraLight.woff2") format("woff2"),
    url("/fonts/iransans/woff/IRANSansWeb_UltraLight.woff") format("woff"),
    url("/fonts/iransans/ttf/IRANSansWeb_UltraLight.ttf") format("truetype");
    font-display: swap;
  }

  body {
    font-family: "IRANSans", "sans-serif";
  }

  img {
    max-width: 90%;
    margin: 0 auto;
  }

  blockquote {
    margin: 5px;
    padding: 3px 10px 3px;
    background: #f1efef;
    border-right: 4px solid #ddd;
    border-radius: 2px;
  }

  a[rel=nofollow] {
    background-color: #f8f7f7;
    padding: 3px;
  }
`

export default CustomContentStyle
